// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DocumentModel from '../../model/document-model';
import DocumentDTO from '../dto/document-dto';
import dtoSchema from '../schemas/document-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class DocumentModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DocumentDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.creatorId = data.creatorId;
      this.creatorName = data.creatorName ?? undefined;
      this.created = data.created;
      this.modifierId = data.modifierId ?? undefined;
      this.modifierName = data.modifierName ?? undefined;
      this.modified = data.modified ?? undefined;
      this.externalId = data.externalId ?? undefined;
      this.fileName = data.fileName ?? undefined;
      this.filePath = data.filePath ?? undefined;
      this.fileExtension = data.fileExtension ?? undefined;
      this.contentLength = data.contentLength;
      this.contentType = data.contentType ?? undefined;
      this.originalFileName = data.originalFileName ?? undefined;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  * @type {int64}
  */
  creatorId?: number;
  /**
  */
  creatorName?: string;
  /**
  * @type {date-time}
  */
  created?: string;
  /**
  * @type {int64}
  */
  modifierId?: number;
  /**
  */
  modifierName?: string;
  /**
  * @type {date-time}
  */
  modified?: string;
  /**
  */
  externalId?: string;
  /**
  */
  fileName?: string;
  /**
  */
  filePath?: string;
  /**
  */
  fileExtension?: string;
  /**
  * @type {int64}
  */
  contentLength?: number;
  /**
  */
  contentType?: string;
  /**
  */
  originalFileName?: string;

  static toModel(dto: DeepPartial<DocumentDTO>): DocumentModel;
  static toModel(dto: DeepPartial<DocumentDTO> | undefined | null): DocumentModel | undefined;
  static toModel(dto: DeepPartial<DocumentDTO> | undefined | null): DocumentModel | undefined {
    return dto ? new DocumentModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DocumentModel> | DocumentModel): DocumentDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      creatorId: unwrapped.creatorId,
      creatorName: unwrapped.creatorName,
      created: unwrapped.created,
      modifierId: unwrapped.modifierId,
      modifierName: unwrapped.modifierName,
      modified: unwrapped.modified,
      externalId: unwrapped.externalId,
      fileName: unwrapped.fileName,
      filePath: unwrapped.filePath,
      fileExtension: unwrapped.fileExtension,
      contentLength: unwrapped.contentLength,
      contentType: unwrapped.contentType,
      originalFileName: unwrapped.originalFileName,
    } as DocumentDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DocumentModel, can not map to DocumentDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
